import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class BaseInput extends React.Component {
  update() {
    this.props.change_ev.bind(this)(this.props.id, this.score.value);
  }
  // -------------------------------------------------------
  
  render() {
    let type = (this.props.type == undefined) ? 'text' : this.props.type;
    
    return (
      <div className="column">
        <h6>{this.props.name}</h6>
        
        <div className="selectbox">
          <select ref={(input) => { this.score = input }} onChange={this.update.bind(this)} defaultValue={this.props.default}>
            { this.props.list.map((d, key) => {
              return <option key={key} value={d.id}>{d.name}</option>
             })}
          </select>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default BaseInput;